/***
 * Created on 2024/3/7
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React from 'react';
import {useTranslation} from "react-i18next";
import {useOnChange} from "../../../../../hook/form";
import {useMutation} from "@tanstack/react-query";
import {apiPost} from "../../../../../service/api";

function VerifyCode({modalRef, dispatch}) {
    const { t } = useTranslation();
    const {onChange, values} = useOnChange({code: ''});

    const verifyMutation = useMutation({
        mutationFn: async (data) => await apiPost('/ajax/qnap_auth/bind', data),
        onSuccess: data => {
            dispatch({type: 'toggleShowSuccess', value: true, device: data.device});
        },
        onError: (error, variables, context) => {
            // const message = error?.cause ? error.cause?.message : error.toString();
            // modalRef.current.alert('error', true, message);
            console.error(error);
        }
    });

    const onVerify = async () => {
        const data = {code: values.code};
        await verifyMutation.mutateAsync(data);
    }

    return (
        <>
            <div className="divider" />
            <p>{t('@Enter the six digit code@')}</p>
            <div className="two-step--verify__action__form">
                <input type="text" name="code" value={values.code} maxLength="6" pattern="\d*" onChange={onChange}/>
                <button className="q-btn q-btn--default btn-rounded-full" disabled={values?.code?.length !== 6} onClick={onVerify}>{t('@Verify@')}</button>
            </div>
        </>
    );
}

export default VerifyCode;